export default {
  title: 'Hoe worden de aandelen verdeeld?',
  description:
    'Doorgaans worden er 120 aandelen uitgegeven bij oprichting van een BV, omdat dit een makkelijk deelbaar aantal is bij meerdere oprichters. Je kan hier echter van afwijken',
  number_of_shares: 'Aantal aandelen',
  shareholders: 'Oprichter(s)',
  warning:
    'Bij een hoog aandelenkapitaal moet de notaris extra werkzaamheden verrichten. Zo geldt er vanaf een aandelenkapitaal van €10.000 een wettelijke onderzoeksplicht voor de notaris naar de herkomst van het vermogen. Omdat dit maatwerk betreft is het via Ligo niet mogelijk om een B.V. op te richten met een aandelenkapitaal hoger dan €10.000. Voor meer informatie kun je met ons contact opnemen via 020-3031043.'
};
